(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('TabFileTypesDeleteController',TabFileTypesDeleteController);

    TabFileTypesDeleteController.$inject = ['$uibModalInstance', 'entity', 'TabFileTypes'];

    function TabFileTypesDeleteController($uibModalInstance, entity, TabFileTypes) {
        var vm = this;
        vm.tabFileTypes = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            TabFileTypes.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
